module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/shenzhen.23481e15.mp3";